<template>
    <div id="NormalInput">
        <a-row>
            <a-col :span="6" class="normalTitle">
                <span>{{data.title}}</span>
                <span v-if="data.valid" class="isValid">*</span>
            </a-col>
            <a-col :span="17" :offset="1" class="normalInputCss">
                <a-row>
                    <a-col>
                        <span v-if="data.inputStyle === 'label'" v-model="data.value">
                        </span>
                        <a-input v-if="data.inputStyle === 'text'"
                                 :disabled="!isCanEdit"
                                 v-model="data.value"
                                 :placeholder="isCanEdit ? data.placeholder : ''"
                                 @onchange="onChange"
                                 @change="onChange"></a-input>
                        <a-input v-if="data.inputStyle === 'number'"
                                 :disabled="!isCanEdit"
                                 v-model="data.value"
                                 class=""
                                 :placeholder="isCanEdit ? data.placeholder : ''"
                                 @onchange="onChange"
                                 @change="onChange"></a-input>
                        <a-textarea v-if="data.inputStyle === 'textarea'"
                                    :disabled="!isCanEdit"
                                    v-model="data.value"
                                    :autoSize="{minRows: 3, maxRows: 6}"
                                    :placeholder="isCanEdit ? data.placeholder : ''"
                                    @change="onChange"></a-textarea>
                        <a-time-picker v-if="data.inputStyle === 'time'"
                                       :disabled="!isCanEdit"
                                       allowClear
                                       v-model="data.value"
                                       @change="onChange"
                                       style="width: 100%"
                                       :placeholder="isCanEdit ? data.placeholder : ''"
                        />
                        <a-date-picker v-if="data.inputStyle === 'date'"
                                       :disabled="!isCanEdit"
                                       allowClear
                                       v-model="data.value"
                                       @change="onChange"
                                       style="width: 100%"
                                       :placeholder="isCanEdit ? data.placeholder : ''"/>

                        <a-date-picker v-if="data.inputStyle === 'dateD'"
                                       :disabled="!isCanEdit"
                                       allowClear
                                       v-model="data.value"
                                       @change="onChange"
                                       style="width: 100%"
                                       :placeholder="isCanEdit ? data.placeholder : ''"/>

                        <a-date-picker v-if="data.inputStyle === 'dateTime'"
                                       :disabled="!isCanEdit"
                                       allowClear
                                       format="YYYY-MM-DD HH:mm:ss"
                                       v-model="data.value"
                                       @change="onChange"
                                       style="width: 100%"
                                       :placeholder="isCanEdit ? data.placeholder : ''"
                                       :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                        />
                        <a-select v-if="data.inputStyle === 'select'"
                                  :disabled="!isCanEdit"
                                  allowClear
                                  v-model="data.value"
                                  style="width: 100%"
                                  :placeholder="isCanEdit ? data.placeholder : ''"
                                  @change="onChange">
                            <a-select-option v-for="(item, index) in data.selectArray" :value="item.value">
                                {{item.name}}
                            </a-select-option>
                        </a-select>

                        <a-input v-if="data.inputStyle === 'localSelect'"
                                 :disabled="!isCanEdit"
                                 v-model="data.value"
                                 class=""
                                 id="localSelectInput"
                                 :placeholder="isCanEdit ? data.placeholder : ''"
                                 @onchange="onChange"
                                 @focus="inputfocus"
                                 @change="onChange"></a-input>
                        <ul v-if="data.inputStyle === 'localSelect'" :class="{'localSelectArea':!localSelectFocus,'localSelectArea_show':localSelectFocus}">
                            <li class="localSelectLi" v-for="(item, index) in localSearchData" :key="index" @click.stop="selectLocal(item)">{{item}}</li>
                        </ul>
                        <a-radio-group v-if="data.inputStyle === 'radio'"
                                       :disabled="!isCanEdit"
                                       v-model="data.value"
                                       @change="onChange">
                            <a-radio v-for="(item, index) in data.selectArray" :key="index" :value="item.value">
                                {{item.name}}
                            </a-radio>
                        </a-radio-group>

                        <a-checkbox v-if="data.inputStyle === 'checkbox'"
                                    :disabled="!isCanEdit"
                                    v-model="data.value"
                                    @change="onChange">
                            {{data.name}}
                        </a-checkbox>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col v-if="!data.isOk" class="errorMsg">
                        {{data.errorMsg}}
                    </a-col>
                </a-row>

            </a-col>

        </a-row>

    </div>
</template>

<script>
    import {checkInput} from './checkAllInput'
    import moment from 'moment'

    export default {
        name: 'NormalInput',
        props: ['data', 'index', 'isCanEdit'],
        data() {
            return {
                isShowErrorMsg: false,
                localSearchData: [],
                selectValue: '',
                localSelectFocus: false
            }
        },
        destroyed() {
        },
        created() {
            this.isShowErrorMsg = this.data.isShowErrorMsg ? this.data.isShowErrorMsg : false
            if (this.data.inputStyle === 'localSelect') {
                this.setLocalShowData(this.data)
            }
        },

        mounted(){
            document.addEventListener('click', (e)=> {
                if (e.target.id !== 'localSelectInput' && e.target.className !== 'localSelectLi') {
                    this.localSelectFocus = false;
                }
            })
        },
        methods: {
            moment,
            selectLocal(value) {
                if (value) {
                    this.data.value = value
                }
                this.localSelectFocus = false;
                this.onChange(this.data)
            },
            setLocalShowData(data) {
                this.localSearchData = []
                const aaa = this.getSearchHistory()
                if (Array.isArray(Object.keys(aaa))) {
                    Object.keys(aaa).forEach(item => {
                        this.localSearchData.push(item)
                    })
                }
                // console.log('this.localSearchData : ', this.localSearchData)
            },
            setSearchHistory(searchString) {
                const name = this.$store.getters.getUserName + this.data.inputStyle + 'History'
                var saveObj = this.getSearchHistory()
                saveObj[searchString] = searchString
                const saveString = JSON.stringify(saveObj)
                localStorage.setItem(name, saveString)
            },
            getSearchHistory() {
                const name = this.$store.getters.getUserName + this.data.inputStyle + 'History'
                var localSave = localStorage.getItem(name) ? localStorage.getItem(name) : ''
                if (localSave) return JSON.parse(localSave)
                return {}
            },
            inputfocus(e) {
                this.localSelectFocus = true;
            },
            inputBlur(e) {
                this.localSelectFocus = false;
            },
            onChange(e) {
                if (this.data.inputStyle === 'date') {
                    const dataString = this.$moment(e).utc(false).utcOffset(1)
                    if (dataString) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = false
                    }
                } else if (this.data.inputStyle === 'dateD') {
                    const dataString = this.$moment(e).utc(false).utcOffset(1)
                    if (dataString) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = false
                    }
                } else if (this.data.inputStyle === 'dateTime') {
                    const dataString = this.$moment(e).utc(false).utcOffset(1)
                    if (dataString) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = false
                    }
                }  else if (this.data.inputStyle === 'time') {
                    if (this.data.value) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = false
                    }
                } else if (this.data.inputStyle === 'number') {
                    if (this.data.value) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = false
                    }
                } else {
                    checkInput(this.data)
                }

                /*
                *  else if (this.data.inputStyle === 'checkbox') {
                    if (this.data.value) {
                        this.data.isOk = true
                    } else {
                        this.data.isOk = true
                    }
                } */
            },

        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #NormalInput {
        margin-top: 20px;
        text-align: right;

        .normalTitle {
            word-wrap: break-word;
            color: rgb(49, 112, 143);
            font-size: 14px;
            font-weight: 700;
        }

        .normalInputCss {
            font-size: 14px;
            font-weight: 400;
            color: #222;
            text-align: left;
        }

        .isValid {
            color: red;
        }

        .errorMsg {
            margin-top: 4px;
            text-align: left;
            color: red;
        }
        .localSelectArea{
            height: 80px;
            display: none;
            list-style: none;
        }
        .localSelectArea_show{
            display: block;
            position: absolute;
            z-index: 999;
            width: 100%;
            max-height: 160px;
            background-color: #ffffff;
            list-style: none;
            margin-left:0px;
            padding-left:0px;
            margin-top: 5px;
            overflow-y: auto;
            overflow-x: hidden;
            border: 1px solid #eeeeee;
            box-shadow: #eeeeee;
            li{
                padding: 10px;
                line-height: 20px;
                border: 1px solid #eeeeee;
            }
            li:hover{
                background-color: #e6f7ff;
            }
        }
    }

</style>
